import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


// REDUX PROPS
interface IDialogProps {
    showError: boolean,
    errorMsg: string,
    buttonHandler: any
}

const ErrorDialog = (props: IDialogProps) => (
    <div>
        <Dialog
            open={props.showError}
            onClose={props.buttonHandler}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">Error</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.errorMsg}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.buttonHandler} color="primary" autoFocus={true}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    </div>
);

export default ErrorDialog;
